// extracted by mini-css-extract-plugin
export default {"root":"styles_root__KqT97","disabled":"styles_disabled__h7JY9"};